<script src="../../router/index.js"></script>
<template>
  <div>
    <van-skeleton title animate :row="8" round="true" :loading="loading_ske">
      <div class="titles">
        角色列表
        <Button type="info" shape="circle" class="role01" size="small" icon="ios-add" @click="addRoles">添加</Button>
        <!--      <Button type="error" shape="circle" class="role01" size="small" icon="ios-close" @click="del">删除</Button>-->
      </div>
      <Table :loading="loading" border ref="selection" :columns="columns7" :data="data6" @on-select="seles" @on-select-all="seleAll"></Table>
      <div class="role02">
        <!--      <Page :total="total" @on-change="nextPage"/>-->
      </div>

      <Modal
        v-model="modal1"
        title="添加角色"
        @on-ok="add"
        @on-cancel="">
        <Input v-model="names">
          <span slot="prepend">角色名称</span>
        </Input>
      </Modal>
    </van-skeleton>
  </div>
</template>

<script>
  import httpRole from '@/api/role';
  import util from "../../util/util";
  export default {
    name: "roleList",
    data() {
      return {
        modal1:false,//是否显示添加模块
        columns7: [
          // {
          //   type: 'selection',
          //   width: 60,
          //   align: 'center'
          // },
          {
            title: '角色名称',
            key: 'roleName',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.roleName)
              ]);
            }
          },
          {
            title: '创建时间',
            key: 'ctime'
          },
          {
            title: '操作',
            key: 'action',
            width: 200,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editQx(params.index)
                    }
                  }
                }, '权限'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.remove(params.index)
                    }
                  }
                }, '删除')
              ]);
            }
          }
        ],
        data6: [],
        page:1,
        pageSize:10,
        total:0,//总数
        loading:false,
        seles:[],          //选中的值
        loading_ske:true,
        names:'',//角色名称
        editId:'',//编辑时的ID
      }
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        userId:'',
        sign:user.sign,
        companyId:user.companyId,
        mobile:user.mobile
      };
      httpRole.roleList(data).then(res => {
        if (res.code == '0000') {
          me.loading_ske = false;
          me.data6 = res.data;
          // me.total = res.show_data.total;
        } else {
          me.$message.error('系统错误');
        }
      })
    },
    methods: {
      addRoles(){
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'权限管理','添加后台角色');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.names = '';
        me.modal1 = true;
      },
      editQx(index){//编辑权限页面
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let user = JSON.parse(sessionStorage.getItem('user'));
        // console.log(me.data6[index]);return false;
        if (user.companyId != 1 && me.data6[index].roleName == '工厂统一角色') {
          me.$message.error('该角色不允许更改');
          return false;
        }
        if (user.companyId != 1 && me.data6[index].roleName == '系统默认') {
          me.$message.error('该角色不允许更改');
          return false;
        }
        let is_auth =  util.is_Auth(menu,'权限管理','分配权限');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({name:'addRole',params:{roleId:me.data6[index].id}})
      },
      seles(e){ //单选时
        var me = this;
        me.seles = e;
      },
      seleAll(e){//全选时
        console.log(e);
      },
      show(index) {
        this.$Modal.info({
          title: '用户详情',
          content: `姓名：${this.data6[index].name}<br>年龄：${this.data6[index].age}<br>地址：${this.data6[index].address}`
        })
      },
      remove(index) {
        // this.data6.splice(index, 1);
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let user = JSON.parse(sessionStorage.getItem('user'));
        if (user.companyId != 1 && me.data6[index].roleName == '工厂统一角色') {
          me.$message.error('该角色不允许更改');
          return false;
        }
        if (user.companyId != 1 && me.data6[index].roleName == '系统默认') {
          me.$message.error('该角色不允许更改');
          return false;
        }
        let is_auth =  util.is_Auth(menu,'权限管理','删除后台角色');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          if (me.data6[index].roleName === '工厂统一角色') {
            me.$message.error('该角色无法删除');
            me.$Loading.error();
            return false;
          }
          if (me.data6[index].roleName === '系统默认') {
            me.$message.error('该角色无法删除');
            me.$Loading.error();
            return false;
          }
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            userId: user.id,
            sign: user.sign,
            roleId: me.data6[index].id,
            companyId: user.companyId,
            mobile:user.mobile
          };
          httpRole.delRole(data).then(res => {
            if (res.code == '0000') {
              me.$message.success('删除成功');
              me.data6.splice(index,1);
              me.$Loading.finish();
            } else {
              me.$message.error('删除失败');
              me.$Loading.error();
            }
          })
        })
      },
      edit(index) {//编辑角色
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let user = JSON.parse(sessionStorage.getItem('user'));
        if (user.companyId != 1 && me.data6[index].roleName == '工厂统一角色') {
          me.$message.error('该角色不允许更改');
          return false;
        }
        if (user.companyId != 1 && me.data6[index].roleName == '系统默认') {
          me.$message.error('该角色不允许更改');
          return false;
        }
        let is_auth =  util.is_Auth(menu,'权限管理','编辑后台角色');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.names = me.data6[index].name;
        me.editId = me.data6[index].id;
        me.modal1 = true;
      },
      del() {//删除用户
        var me = this;
        me.$message.error('暂未选择数据');
      },
      add(){//添加角色
        var me = this;
        if (me.names === "") {
          me.$message.error('请输入角色名称');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          userId:user.id,
          sign:user.sign,
          companyId:user.companyId,
          mobile:user.mobile,
          name:me.names,
        };
        if (me.editId !== '') {
          data['id'] = me.editId;
        }
        me.$Loading.start();
        httpRole.addRole(data).then(res => {
          switch (res.code) {
            case '1111':
              me.$message.error('添加失败');
              me.$Loading.error();
              break;
            case '0000':
              me.names = '';
              if (me.editId === '') {
                me.$message.success('添加成功');
              } else {
                me.$message.success('编辑成功');
              }
              me.$Loading.finish();
              me.editId = '';
              me.getData();
              break;
          }
        })
      },
      getData(){
        var me = this;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          userId:'',
          sign:user.sign,
          companyId:user.companyId,
          mobile:user.mobile
        };
        httpRole.roleList(data).then(res => {
          if (res.code == '0000') {
            me.data6 = res.data;
          } else {
            me.$message.error('系统错误');
          }
        })
      },
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          userId:user.id,
          sign:user.sign,
          mobile:user.mobile,
          page:e,
          pageSize:me.pageSize
        };
        httpRole.roleList(data).then(res => {
          if (res.status === 10000) {
            me.data6 = res.show_data.data;
            me.loading = false;
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import "roleList.css";
</style>
